exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr.marked td[data-v-1e580ea6],tr.marked th[data-v-1e580ea6]{border-top:3px solid red;border-bottom:3px solid red}tr.marked th[data-v-1e580ea6]:first-child{border-left:3px solid red}tr.marked td[data-v-1e580ea6]:last-child{border-right:3px solid red}", ""]);

// exports
